module.exports = __webpack_public_path__ + "static/img/report.d68f3074.svg";